import { render } from "./ProfileDeleteAccount.vue?vue&type=template&id=67e9dcc8"
import script from "./ProfileDeleteAccount.vue?vue&type=script&lang=js"
export * from "./ProfileDeleteAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__